import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SocketState {
  isConnected: boolean;
  isInitialized: boolean;
}

const initialState: SocketState = {
  isConnected: false,
  isInitialized: false,
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocketConnected(state, action: PayloadAction<boolean>) {
      state.isConnected = action.payload;
    },
    setSocketInitialized(state, action: PayloadAction<boolean>) {
      state.isInitialized = action.payload;
    },
  },
});

export const { setSocketConnected, setSocketInitialized } = socketSlice.actions;
export default socketSlice.reducer;